import React from "react";
import { Button } from "@sainsburys-tech/fable";

const UnderlinedButton = props => (
  <div className="fable:m-1">
    <Button variant="tertiary" colourScheme="dark" {...props}>{props.children}</Button>
  </div>
);

export default UnderlinedButton;
